import { useId } from "react";
import { useTranslation } from "react-i18next";

/** A textarea that stops at `maxLength` and shows how much is used. */
export function CharCountTextarea({
	label,
	value,
	onChange,
	maxLength,
	placeholder,
	rows = 4,
}: {
	label: string;
	value: string;
	onChange: (value: string) => void;
	maxLength: number;
	placeholder?: string;
	rows?: number;
}) {
	const { t } = useTranslation();
	const id = useId();
	const countId = useId();
	return (
		<div className="flex flex-col gap-1.5">
			<label
				htmlFor={id}
				className="font-mono text-xs font-semibold uppercase tracking-wider text-dashboard-muted"
			>
				{label}
			</label>
			<textarea
				id={id}
				value={value}
				maxLength={maxLength}
				aria-describedby={countId}
				onChange={(event) => onChange(event.target.value)}
				placeholder={placeholder}
				rows={rows}
				className="w-full resize-y rounded-[7px] border border-dashboard-border bg-dashboard-warm-450 px-3.5 py-2.5 font-body text-sm text-dashboard-text outline-none transition-all duration-200 focus:border-dashboard-accent focus:shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-dashboard-accent)_12%,transparent)]"
			/>
			<span
				id={countId}
				className="self-end font-mono text-xs text-dashboard-muted"
			>
				{t("onboarding.fields.charCount", {
					count: value.length,
					max: maxLength,
				})}
			</span>
		</div>
	);
}
